import sponsorsSlider from "./sponsors-slider"

export default {
	init() {
		const $load_chefs_wrapper = $("#mozaik-chefs")
		const $load_chefs_skeleton = $("#mozaik-chefs .chefs-skeleton")
		const $searchChefs_input = $("#search-chefs")
		const $searchChefs_btn = $("#search-chefs-btn")
		const $posts_wrapper = $("#mozaik-chefs .more-posts")
		const $loadmore_button = $("#mozaik-chefs .loadmore-category")
		const $more_wrapper = $("#mozaik-chefs .more-wrapper")
		let loaded_post_ids = []
		let page = 1
		let activeRequest = null
		let requestSerial = 0

		if ($load_chefs_wrapper.length > 0) {
			//  Initial loading of posts
			let loaded_post_element = $("#loaded_post_ids")

			if (loaded_post_element.length) {
				if (loaded_post_element.val() != "") {
					loaded_post_ids = loaded_post_element.val().split(",") // prepare visible chefs ID lis
				}
			}

			loadChefs()

			// Load More button trigger
			$loadmore_button.on('click', function (e) {
				e.preventDefault()
				loadChefs(true)
			})

			// Change Filters
			$("input[type=radio][name=pokrajina], input[type=radio][name=ocena], select[name=order_select]").on('change', function () {
				page = 1
				loaded_post_ids = []

				// return Load more pages button
				$more_wrapper.css({ visibility: "visible" })
				$searchChefs_input.val("")

				loadChefs()
			})

			$searchChefs_input.on("keydown", function (e) {
				if (e.key == "Enter") {
					$searchChefs_btn.trigger("click")
				}
			})

			$searchChefs_btn.on('click', function (e) {
				$(this).prop("disabled", true)
	
				page = 1
				loaded_post_ids = []

				// Reset regija radio
				$("input[type=radio][name=pokrajina]:checked").prop("checked", false)
				$("input[type=radio][name=pokrajina]#pokrajina-all").prop("checked",true)

				// Reset rating raio
				$("input[type=radio][name=ocena]:checked").prop("checked", false)
				$("input[type=radio][name=ocena]#unrated").prop("checked", true)
	
				// return Load more pages button
				$more_wrapper.css({ visibility: "visible" })
	
				loadChefs()
			})

		}
		
		function loadChefs(loadmore = false) {
			let filterValues = getFilterValues()
			const countSpan = $("#res-count")
			countSpan.hide()

			const requestedPage = loadmore ? page + 1 : 1

			if (!loadmore) {
				//skeleton
				$load_chefs_skeleton.addClass("grid").show()
				$posts_wrapper.removeClass("grid").addClass("hidden")
			}

			const requestId = ++requestSerial
			if (activeRequest) {
				activeRequest.abort()
			}

			const data = {
				page: requestedPage,
				search: filterValues.search,
				loaded_post_ids: loaded_post_ids,
				pokrajina: filterValues.pokrajina,
				ocena: filterValues.ocena,
				order_select: filterValues.order_select,
			}


			activeRequest = $.ajax({
				url: '/wp-json/vivi/v1/chefs',
				method: 'POST',
				data: data,
				beforeSend: function () {
					// Load more button
					if($loadmore_button.length > 0) {
						$loadmore_button.prop("disabled", true).text(loading_text)
					}
				},
				success: function (response) {
					if (requestId === requestSerial && response) {
						if (loadmore) {
							$posts_wrapper.append(response.content)
						} else {
							$posts_wrapper.html(response.content)
							
							//skeleton
							$load_chefs_skeleton.hide()
							$posts_wrapper.removeClass("hidden").addClass("grid")
						}

						sponsorsSlider.init()

						page = requestedPage
						loaded_post_ids = Array.isArray(response.loaded_post_ids) ? response.loaded_post_ids : []

						const hasMore = typeof response.has_more === "boolean"
							? response.has_more
							: response.total_posts_count > response.current_count
						$more_wrapper.css({ visibility: hasMore ? "visible" : "hidden" })
						
						// Update Counter
						if(countSpan.length) {
							countSpan.text("(" + response.total_posts_count + ")").show()
						}
					}
				},
				error: function (xhr, status) {
					if (requestId !== requestSerial || status === "abort") {
						return
					}

					$load_chefs_skeleton.hide()
					$posts_wrapper.removeClass("hidden").addClass("grid")
					console.error("Chefs could not be loaded.", status)
				},
				complete: function () {
					if (requestId !== requestSerial) {
						return
					}

					activeRequest = null
					$searchChefs_btn.prop("disabled", false)
					$loadmore_button.prop("disabled", false).text(loading_more_text_simple)
				},
			})
		}


		function getFilterValues() {
			let pokrajina = $("input[name='pokrajina']:checked")[0].value
			let ocena = $("input[name='ocena']:checked")[0].value
			let order_select = $("select[name='order_select']").val()
			let search = $searchChefs_input.val()
        
            return {
                'pokrajina': pokrajina, 
                'ocena': ocena,
                'search': search,
                'order_select': order_select
            }
		}
		
	}
}
